// extracted by mini-css-extract-plugin
module.exports = {"Contain":"Image_Contain__gRw0S","Cover":"Image_Cover__1Xm3L","Slide":"Image_Slide__26vS0","Auto":"Image_Auto__46Ybp","IEImage":"Image_IEImage__3yxBu"};